import 'zone.js';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

// Sentry only where the build's environment file sets a DSN (production); the environment name comes from
// the same file, so a staging build never reports as production
if (environment.sentryDsn) {
	Sentry.init({
		dsn: environment.sentryDsn,
		environment: environment.sentryEnvironment,

		// Integrations
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.captureConsoleIntegration({ levels: ['error'] }),
			Sentry.globalHandlersIntegration({ onerror: true, onunhandledrejection: true }),
			// Only server errors: 4xx are expected answers (wrong password, validation) and would flood it
			Sentry.httpClientIntegration({ failedRequestStatusCodes: [[500, 599]] }),
		],

		// Sampling. No session replays: they record what customers see and type
		tracesSampleRate: 0.2,

		// PII: no IPs, cookies or user data (customers' data must not leave for a third party)
		sendDefaultPii: false,

		// Custom hooks
		beforeSend(event) {
			if (typeof navigator !== 'undefined') {
				event.contexts = {
					...event.contexts,
					network: {
						online: navigator.onLine,
						connection: (navigator as any).connection?.effectiveType || 'unknown',
						downlink: (navigator as any).connection?.downlink || 'unknown',
					},
				};
			}
			return event;
		},

		debug: false,
	});
}

if (environment.production) {
	enableProdMode();
	// Silence verbose console output in production. console.error is kept so that
	// Sentry's captureConsoleIntegration({ levels: ['error'] }) still receives it.
	window.console.log = () => {};
	window.console.debug = () => {};
	window.console.info = () => {};
	window.console.warn = () => {};
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
	console.error(err);
	Sentry.captureException(err);
});
